// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"styles-module--breadcrumb--2IVwB"};